// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EGJj","question":"styles_question__3G09q","description":"styles_description__2dFEd"};